import Marquee from "react-fast-marquee";
import { industries } from "@/data/content";

export default function ClientMarquee() {
  return (
    <section data-testid="client-marquee" className="border-b border-line bg-ink py-8 sm:py-10 md:py-12 lg:py-14">
      <p className="mx-auto mb-8 max-w-[1600px] px-5 text-xs font-bold uppercase tracking-[0.2em] text-bone/40 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        Trusted across 12 industries
      </p>
      <Marquee speed={34} gradient={false} pauseOnHover className="marquee-track">
        {industries.map((ind, i) => (
          <span key={ind.slug} className="mx-8 flex items-center gap-8 md:mx-12">
            <span
              className={`font-display text-4xl font-extrabold md:text-6xl ${
                i % 2 === 0 ? "text-bone" : "stroke-bone"
              }`}
            >
              {ind.name}
            </span>
            <span className="font-serif text-3xl italic text-accent md:text-4xl">#</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
